import React from 'react'
import Tippy from "@tippyjs/react"
import "tippy.js/dist/tippy.css"
import "tippy.js/themes/light-border.css"

import { bikeCategories } from "../../../../constants"

import ChipGroup from "../../../../components/search/filters/filterInputs/chipGroup"


const StyleFilterPopup = props => {
  const {
    open, onClose, onOpen, children,
    currentValues, showLabel, showIcon,
    placeHolder, applyBorder
  } = props

  return (
    <>
      <Tippy
        trigger="click"
        sticky={true}
        arrow={false}
        hideOnClick={true}
        theme="light-border"
        animation={false}
        visible={open}
        onClickOutside={() => onClose()}
        interactive={true}
        placement={"bottom-start"}
        content={children}
        maxWidth={700}
        className={"search-filter-modal"}
        onMount={() => onOpen()}
        onHide={() => onClose()}
      >
        <div className='has-search-element is-gapless'>
          {showLabel && <span className="search-bar-label">Style</span>}
          <div className='bike-style-control pl-2'>
            {showIcon && <img src='/static/images/styleFilterIcons/standard.svg' alt='home style icon'/>}
            <div
              onClick={onOpen}
              className={`input pl-1 mb-0 ${applyBorder ? "" : "preferred-style-field"} ${currentValues.length <= 0 ? 'empty' : ''}`}
            >
              {currentValues.length <= 0 ?
                placeHolder : 
                <span className='is-capitalized'>
                  {currentValues.join(", ")}
                </span>
              }
            </div>
          </div>
        </div>
      </Tippy>
    </>
  )
}

const StyleFilter = props => {
  const {
    currentValues, onSelect, onOpen, onClose,
    open, showIcon = true, showLabel = true,
    placeHolder = "Preferred style", onStyleSelect,
    applyBorder = false, disableAllStyle = false
  } = props

  return (
    <StyleFilterPopup
      open={open}
      onOpen={onOpen}
      onClose={onClose}
      currentValues={currentValues}
      showIcon={showIcon}
      showLabel={showLabel}
      placeHolder={placeHolder}
      applyBorder={applyBorder}
    >
      <div className="style-filter-container">
        <ChipGroup
          chipType='bikeCategories'
          chipData={bikeCategories}
          className='aligned-chip'
          labelKey={"catLabel"}
          valueKey={"catName"}
          iconKey={"catIconUrl"}
          disableAllStyle={disableAllStyle}
          onChange={(values) => {
            if (onStyleSelect) {
              let latestValue = values[values.length - 1]
              // Ensures single selection
              onStyleSelect(latestValue ? [latestValue] : [])
            } else {
              onSelect(values)
            }
          }}
          selectedChips={currentValues}
        />
      </div>
    </StyleFilterPopup>
  )
}

export default StyleFilter